import React, { FC, useEffect, useRef, useState } from 'react';
import { IonProgressBar } from '@ionic/react';
import { AnalyseProgressWrapper } from './AnalyseProgress.style';
import { FormattedMessage } from 'react-intl';

type AnalyseProgressProps = {
  itemsCount: number;
  onFinish: () => void;
};

const AnalyseProgress: FC<AnalyseProgressProps> = ({ itemsCount, onFinish }) => {
  const [progress, setProgress] = useState(0);

  const interval = useRef<NodeJS.Timeout>();

  useEffect(() => {
    if (itemsCount) {
      interval.current = setInterval(
        () => {
          setProgress((prev) => (prev === 1 ? prev : Number((prev + 0.01).toFixed(2))));
        },
        (itemsCount * 1.5 + 3) * 10
      );
    } else {
      clearInterval(interval.current);
      interval.current = undefined;
    }

    return () => clearInterval(interval.current);
  }, [interval, itemsCount]);

  useEffect(() => {
    if (progress === 1) {
      clearInterval(interval.current);
      interval.current = undefined;
      setTimeout(async () => {
        onFinish();
      }, 1000);
    }
  }, [progress, interval]);

  return (
    <AnalyseProgressWrapper>
      <div className="progress-title">
        <FormattedMessage id={'on-boarding.info.analyse.answers'} defaultMessage={'АНАЛІЗ ВІДПОВІДЕЙ'} />
      </div>
      <div className="progress-wrapper">
        <IonProgressBar value={progress} />
        <span className="progress-value">{Math.ceil(progress * 100)}%</span>
      </div>
    </AnalyseProgressWrapper>
  );
};

export default AnalyseProgress;
